
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('path',{attrs:{"d":"M29.564 25.512a4.473 4.473 0 014.466 4.483c0 3.279-4.466 8.276-4.466 8.276s-4.483-5.033-4.483-8.293a4.473 4.473 0 014.483-4.466zm0 6.326c1.028 0 1.843-.85 1.843-1.86 0-1.01-.815-1.843-1.843-1.843-1.027 0-1.843.85-1.843 1.86 0 1.01.816 1.843 1.843 1.843zm6.495-11.3c.512 0 .91.398.91.881v3.978c0 .511-.398.909-.91.909h-2.074c-.156.285-.6.778-.778 1.045-.017-.036-.118-.16-.302-.371-.277-.317-.508-.492-.654-.61a5.152 5.152 0 00-.775-.478 6.96 6.96 0 00-.943-.335c.057-.369.44-1.723.44-2.12 0-4.149-3.355-7.501-7.504-7.501a7.495 7.495 0 00-7.503 7.5c0 4.149 3.386 6.984 7.503 7.501.384.048 1.314.142 1.679.095.204.666.373 1.147.507 1.443.075.167.18.431.303.66l.41.757v2.074c0 .483-.398.91-.91.91H21.48a.898.898 0 01-.909-.91v-2.074c-.881-.199-1.705-.568-2.473-.994l-1.478 1.477a.877.877 0 01-1.279 0l-2.813-2.813a.876.876 0 010-1.278l1.45-1.478a11.904 11.904 0 01-1.024-2.472h-2.075a.916.916 0 01-.91-.909v-3.978c0-.51.399-.909.91-.909h2.132c.199-.88.568-1.704.995-2.472l-1.478-1.477a.876.876 0 010-1.279l2.813-2.812a.877.877 0 011.28 0l1.477 1.477a11.911 11.911 0 012.473-1.023v-2.074c0-.511.398-.909.91-.909h4.007c.511 0 .91.398.91.91v2.073c.88.228 1.705.568 2.472.995l1.478-1.478a.877.877 0 011.279 0l2.813 2.813a.91.91 0 010 1.307l-1.477 1.477c.426.768.767 1.592 1.023 2.472h2.074z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/techLocalFill.svg